module.exports = function(name, value, source) {
    this.name = name;
    this.value = value;
    if (source) {
        this.source = source;
    }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/lop/lib/Token.js
// module id = 698
// module chunks = 0